/**
 * @generated SignedSource<<70e1b6f89bab5265fb91f320aacd50d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubLogoNotificationsFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly logoImage: {
          readonly publicId: string;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ClubLogoNotificationsFragment_session";
};
export type ClubLogoNotificationsFragment_session$key = {
  readonly " $data"?: ClubLogoNotificationsFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubLogoNotificationsFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubLogoNotificationsFragment_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Image",
                  "kind": "LinkedField",
                  "name": "logoImage",
                  "plural": false,
                  "selections": [
                    {
                      "alias": "publicId",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "renderingKey",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "6e836ca5e425e39b376158f2ead905c4";

export default node;
